/**
 * extracting and processing comments from request progresses.
 */

/**
 * Extracts all unique comments from request progresses, deduplicated by ID and sorted by createdAt.
 *
 * @param {Array} requestsProgresses - Array of request progress objects
 * @returns {Array} Array of unique comments sorted by createdAt (oldest first)
 */
export const extractUniqueCommentsFromProgresses = (requestsProgresses) => {
  if (!requestsProgresses || !Array.isArray(requestsProgresses)) {
    return [];
  }

  const allCommentsMap = new Map(); // Use Map to deduplicate by comment ID

  for (const progress of requestsProgresses) {
    const progressComments = progress?.end_user_filled_form?.comments || [];

    for (const comment of progressComments) {
      // Deduplicate by comment ID - keep the first occurrence
      if (comment.id && !allCommentsMap.has(comment.id)) {
        allCommentsMap.set(comment.id, comment);
      }
    }
  }

  // Convert Map to array and sort by createdAt (chronological order)
  const allUniqueComments = Array.from(allCommentsMap.values()).sort((a, b) => {
    const dateA = new Date(a.createdAt || 0);
    const dateB = new Date(b.createdAt || 0);
    return dateA - dateB; // Ascending order (oldest first)
  });

  return allUniqueComments;
};
